import useTranslation from 'next-translate/useTranslation';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { IeltsListeningReadingWritingQuestion } from '@/types';
import IeltsListeningExplainButton from '../ExplainButton';
import IeltsListeningReportButton from '../ReportButton';

export default function ExplainSelectDetail({
  detail,
  showContentKey,
}: {
  detail: IeltsListeningReadingWritingQuestion['node']['details'][number];
  showContentKey?: boolean;
}) {
  const { lang, t } = useTranslation('ielts');
  const [openExplain, setOpenExplain] = useState(false);

  const toggleExplain = () => setOpenExplain((prev) => !prev);

  const explainHtml = (lang === 'vi' ? detail.explainHtml : detail.explainHtmlEn) || '';

  return (
    <div>
      <div className="flex items-center gap-x-3">
        <p className="font-semibold">
          {showContentKey && <span>{detail.contentKey} </span>}
          {t('listening_reading.answers')}:{' '}
          {detail.options
            ?.filter((o) => o.correctAnswer)
            .map((o) => o.label)
            .join(' ,')}
        </p>

        {explainHtml && <IeltsListeningExplainButton onClick={toggleExplain} />}
        {/* <IeltsListeningReportButton /> */}
      </div>
      <div
        className={twMerge(
          'transition-max-height duration-500 ease-in-out overflow-hidden',
          openExplain ? 'max-h-screen py-5' : 'max-h-0',
        )}
        dangerouslySetInnerHTML={{
          __html: explainHtml,
        }}
      />
    </div>
  );
}
